// src/store/deploySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../../utils";

// Async thunks
export const sendOrder = createAsyncThunk(
    "deploy/order",
    async (payload) => {
        const res = await apiFetch("api/haki/order", {
            method: "POST",
            body: JSON.stringify(payload),
            idempotencyAction: "deploy:order"
        });
        if (!res.ok) throw new Error("Order Failed");
        alert("Order Submitted");
        return await res.json();
    }
);

export const getDeployable = createAsyncThunk(
    "deploy/fetch",
    async () => {
        const res = await apiFetch("api/haki/deploy");
        return await res.json();
    }
);

const initialState = {
    loading: false,
    error: null,
    deployableData: {}
};

const deploySlice = createSlice({
    name: "deploy",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // sendOrder
            .addCase(sendOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendOrder.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendOrder.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // getDeployable
            .addCase(getDeployable.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDeployable.fulfilled, (state, action) => {
                state.deployableData = action.payload;
                state.loading = false;
            })
            .addCase(getDeployable.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const {
    setOrderData
} = deploySlice.actions;

export default deploySlice.reducer;
